import React from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import StyledSelect from "~styled/select/StyledSelect";

const PhoneTipoSelector = ({ key, value, onChange }) => {
  const labelId = `moneda-label-${key ? key : "0"}`;

  return (
    <FormControl>
      <InputLabel
        sx={{
          transform: "translate(0, 12px) scale(1)",
          transformOrigin: "top left",
          "&.MuiInputLabel-shrink": {
            transform: "translate(0, -1px) scale(0.75)",
          },
        }}
        id={labelId}
      >
        TIPO
      </InputLabel>
      <StyledSelect
        variant="standard"
        labelId={labelId}
        value={value}
        style={{ minWidth: 81, alignContent: "start" }}
        onChange={onChange}
      >
        <MenuItem value={true}>MÓVIL</MenuItem>
        <MenuItem value={false}>FIJO</MenuItem>
      </StyledSelect>
    </FormControl>
  );
};

export default PhoneTipoSelector;
